export const UPDATE_TIER0 = 'update_tier0';
export const UPDATE_TIER1 = 'update_tier1';
export const UPDATE_TIER2 = 'update_tier2';
export const UPDATE_AVAILABILITY = 'update_availability';
export const UPDATE_DOMAIN_CONTROLLER_SERVICES = 'update_domain_controller_services';
export const UPDATE_AD_ATTRIBUTES = 'update_ad_attributes';
export const NOTIFY_DOWNLOAD_SCRIPT = 'notify_download_script';
export const UPDATE_ACCOUNTS = 'update_accounts';
export const UPDATE_ITSM = 'update_itsm';
